import {firebaseFirestore, firebaseStorage} from "./firebase";


class Firestore {


    foods = () => firebaseFirestore.collection("food");
    users = () => firebaseFirestore.collection("users");
    currentUser = (uid) => firebaseFirestore.collection("users").doc(uid);


    imageStorage = (id) => firebaseStorage.ref().child('food/' + id + '.jpg')

}

const firestore = new Firestore();
export default firestore


